__turbopack_context__.v({
  "btnContainer": "_58VrMG_btnContainer",
  "magicModalFadeIn": "_58VrMG_magicModalFadeIn",
  "modal": "_58VrMG_modal",
  "modalContainer": "_58VrMG_modalContainer",
  "root": "_58VrMG_root",
  "srOnly": "_58VrMG_srOnly",
});
